// R1b-α Fix #1 — Owner-only route gate.
// Wraps a route so only OWNER_SUPER_ADMIN can render. Non-owners are redirected once to their role home
// (`user.home_route`, resolved by the backend to a page that role can open); a would-be loop renders the
// access-denied page (B2a: EMPLOYEE was stuck on "Redirecting…" because its stored home was /owner).
// This runs BEFORE `AdminAppShell` mounts, so no shell chrome leaks.
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import RoleDenied from "./RoleDenied";

export default function OwnerOnlyRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-erf-cream">
        <div className="font-mono text-xs text-erf-dark/60">Authenticating…</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (user && user.must_rotate_password) return <Navigate to="/auth/rotate" replace />;
  if (user.role_key !== "OWNER_SUPER_ADMIN") return <RoleDenied user={user} />;
  return children;
}
